import { render, staticRenderFns } from "./PlatformCredit.vue?vue&type=template&id=08145aa6&scoped=true&"
import script from "./PlatformCredit.vue?vue&type=script&lang=js&"
export * from "./PlatformCredit.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCredit.vue?vue&type=style&index=0&id=08145aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08145aa6",
  null
  
)

export default component.exports